import { BaseService } from 'core/services';
import CorporateContactRouteService from './CorporateContactRouteService';

class CorporateContactService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CorporateContactRouteService());
    }
}

export default CorporateContactService;
